<template>
    <transition name="fade">
        <div id="div-aside" class="column is-2 is-fullheight sidebar-default" v-if="sidebarIsOpened">
            <aside  class="menu">
                <p class="menu-label">
                    <button class="delete is-small is-pulled-right" id="close-sidebar" aria-label="close" @click="SET_SIDEBAR(false)" title="Fechar o menu"></button>
                </p>
                <figure class="image is-64x64 has-image-centered is-hidden-mobile">
                    <img v-if="foto==null" class="is-rounded" src="../assets/pessoa.png">
                    <img v-else class="is-rounded" :src="foto">
                </figure>
                <h4 class="title is-6 has-text-centered is-marginless">
                    {{ usuario.apelido ?? usuario.nome }}
                </h4>
                <p class="is-size-7 has-text-centered">
                    {{ usuario.nivel }}
                </p>
                <hr class="dropdown-divider">

                
                <span>

                
                    <b-field v-if="usuario.administrador && alterandoUnidade" 
                            label="Unidade" 
                            label-position="on-border">
                        <b-select size="is-small" v-model="unidadeId"
                                expanded>
                            <option v-for="(item, index) in unidades" 
                                    v-bind:key="index" 
                                    :value="item.id">{{item.nome}}</option>
                        </b-select>
                    </b-field>
                    <p v-else class="is-size-7 has-text-centered">
                        Unidade: <b>{{unidadeNome}}</b>
                        <a v-if="usuario.administrador" href="#" class="has-text-grey" @click="alterandoUnidade = true" title="Alterar unidade">
                            <b-icon  icon="pencil" size="is-small"></b-icon>
                        </a>                    
                    </p>                    

                </span>



                <hr class="dropdown-divider">


                <ul class="menu-list">

                    <li v-if="isInRole('rh-diretoria') || isInRole('rh-lider') || isInRole('rh-colaborador')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-dashboard' }">
                            <b-icon icon="view-dashboard-outline" size="is-small"></b-icon> MetaVirtue
                        </router-link>
                    </li>
                    <li v-if="isInRole('rh-diretoria') || isInRole('rh-lider') || isInRole('rh-colaborador')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-diagnostico' }">
                            <b-icon icon="clipboard-text-outline" size="is-small"></b-icon> Diagnóstico 9D
                        </router-link>
                    </li>
                    <li v-if="isInRole('rh-diretoria') || isInRole('rh-lider') || isInRole('rh-colaborador')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-desenvolvimento' }">
                            <b-icon icon="account-heart-outline" size="is-small"></b-icon> Desenvolvimento
                        </router-link>
                    </li>
                    <li v-if="isInRole('rh-diretoria') || isInRole('rh-lider')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-pessoas' }">
                            <b-icon icon="account-multiple-outline" size="is-small"></b-icon> Pessoas
                        </router-link>
                    </li>
                    <li v-if="isInRole('rh-diretoria') || isInRole('rh-lider')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-agenda' }">
                            <b-icon icon="calendar-month" size="is-small"></b-icon> Agenda
                        </router-link>
                    </li>
                    <li v-if="isInRole('rh-diretoria')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'rh-configuracao' }">
                            <b-icon icon="tune" size="is-small"></b-icon> Método e privacidade
                        </router-link>
                    </li>

                    <li v-if="isInRole('pdv-dashboard') || isInRole('pdv-relatorios-consultar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'pdv-dashboard' }" exact>
                            <b-icon icon="view-dashboard" size="is-small"></b-icon> Dashboard
                        </router-link>
                    </li>
                    <li v-if="isInRole('pdv-vendas-consultar') || isInRole('pdv-vendas-realizar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'pdv-vendas' }">
                            <b-icon icon="cart" size="is-small"></b-icon> Vendas
                        </router-link>
                    </li>
                    <!-- por enquanto sem relatorios
                    <li v-if="isInRole('pdv-relatorios-consultar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'pdv-relatorios' }">
                            <b-icon icon="chart-bar" size="is-small"></b-icon> Relatórios
                        </router-link>
                    </li>
                    -->
                    <li v-if="isInRole('pdv-produtos-consultar') || isInRole('pdv-produtos-alterar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'pdv-produtos' }">
                            <b-icon icon="package-variant" size="is-small"></b-icon> Produtos
                        </router-link>
                    </li>

  
                    <li  v-if="isInRole('menu-manutencao')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'manutencao' }">
                            <b-icon icon="cog" size="is-small"></b-icon> {{$t('SISTEMA.MANUTENCAO')}}
                        </router-link>
                    </li>                                      
                </ul>
                <hr class="dropdown-divider">
                <ul class="menu-list">
                    <li>
                        <a @click="logout">
                            <b-icon icon="logout" size="is-small"></b-icon>
                            {{$t('SISTEMA.SAIR')}}
                        </a>
                    </li>
                </ul>
            </aside>
        </div>
    </transition>    
</template>

<script>
    import { mapActions, mapState, mapGetters } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        data() {
            return {
                alterandoUnidade: false,
                foto: null,       
                unidadeEmpresaId:null,
            }
        },
        computed: {
            ...mapState([
                'config',
                'usuario',
                'unidadeId',
                'unidades'                
            ]),
            ...mapState('componentes', [
                'sidebarIsOpened'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
            unidadeId: {
                get() {
                    return this.$store.state.unidadeId;
                },
                set(value) {
                    this.alterandoUnidade = false;
                    this.$store.commit('SET_UNIDADE', value);
                }
            },
            unidadeNome() {
                const unidade = this.unidades?.find(x => x.id == this.unidadeId);
                return unidade?.nome;
            },
        },
        created(){
            this.getImage();
        },
        methods: {

            getImage() {
                if (!this.foto){                    
                    this.foto = '/api/manutencao/funcionarioFoto?id=' + this.usuario.funcionarioId +`&_cl=${new Date().getTime()}`;
                }

                return this.foto;
            },            
            ...mapActions([
                'logout'
            ]),
            ...mapMutations('componentes', [
                'HANDLE_RESIZE',
                'SET_SIDEBAR',
            ])
        }
}
</script>
